import { render, staticRenderFns } from "./SendErrorModal.vue?vue&type=template&id=81a4b452&"
import script from "./SendErrorModal.vue?vue&type=script&lang=ts&"
export * from "./SendErrorModal.vue?vue&type=script&lang=ts&"
import style0 from "./SendErrorModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports